export default __webpack_public_path__ + "images/72132e682c79fd350d0d5609235489bd-knitting_small.webp";